// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2BjFi","right":"styles_right__wxPYg"};